import '@bjb/bjb-web-components/dist/components/jb-cookie-consent/jb-cookie-consent.js';
import type { JbCookieConsent } from '@bjb/bjb-web-components/dist/components/jb-cookie-consent/jb-cookie-consent.js';
import { JbPopup } from '@bjb/bjb-web-components/dist/components/jb-popup/jb-popup.js';

import { getCookie, setCookie } from '../modules/cookie';
import { getI18nCookieData } from '../modules/i18n';

function showCookieConsentOnPageLoad(): void {
  const disabledForMarkets = document.body.dataset.disableConsentBannerForMarkets;
  if (disabledForMarkets !== undefined) {
    const userMarket = getI18nCookieData().market || '';
    if (userMarket && disabledForMarkets.split(',').includes(userMarket)) {
      setCookie('allow_tracking_cookies', '1');
      setCookie('allow_marketing_cookies', '1');
      return;
    }
  }

  // If tracking cookies were set without explicit user consent (no hide_cookie_banner),
  // the user has navigated away from a market where consent was auto-suppressed — clear them.
  if (!getCookie('hide_cookie_banner') && (getCookie('allow_tracking_cookies') || getCookie('allow_marketing_cookies'))) {
    setCookie('allow_tracking_cookies', '', -1);
    setCookie('allow_marketing_cookies', '', -1);
  }

  if (
    getCookie('hide_cookie_banner') &&
    (!getCookie('show_cookie_banner') || getCookie('show_cookie_banner') === '0')
  ) {
    return;
  }

  const originalCookieConsent = document.querySelector('jb-cookie-consent:not([data-clone])') as JbCookieConsent | null;
  if (!originalCookieConsent || !originalCookieConsent.showOnPageLoad) {
    return;
  }

  const cookieConsent = originalCookieConsent.cloneNode(true) as JbCookieConsent;
  cookieConsent.setAttribute('data-clone', '');

  const { country, languageIso2 } = getI18nCookieData();
  cookieConsent.country = country || undefined;
  cookieConsent.currentLanguageIso2 = languageIso2 || undefined;

  cookieConsent.open();

  new JbPopup().init({ props: { preventCloseByBackgroundClick: true }, childNodes: [cookieConsent] }).stack();
}

showCookieConsentOnPageLoad();
